import { ENUM_TIPO_PESSOA, TIPO_DOCUMENTO } from 'utils/consts';
import { convertDate, convertDatePtBr } from 'utils/dateFormatter';
import { primeiraLetraPalavraUpperCase } from 'utils/funcaoPadrao';
import { cepMaskView, cnpjMaskView, cpfMaskView, telefoneMask } from 'utils/masks';
import { removeEspacos, removeTodasMascaras } from 'utils/stringFormatter';

const removerMascaraInputs = dadosInputs => {
  const {
    tipoPessoa,
    cpf,
    telefone,
    cep,
    inscricaoEstadual,
    inscricaoMunicipal,
    cnpj,
    dataNascimento,
    profissaoId,
    escolaridadeId,
    sexoId,
    instituicaoId,
    areaAtuacaoId,
    cargoRepresentante,
    enderecoPf,
    enderecoPj,
  } = dadosInputs;

  const dataNascimentoFormatada =
    dataNascimento?.toString()?.split('/')?.length > 1 ? convertDate(dataNascimento) : dataNascimento;

  const tipoPessoaFormatada =
    ENUM_TIPO_PESSOA.fisica.descricao === tipoPessoa ? ENUM_TIPO_PESSOA.fisica : ENUM_TIPO_PESSOA.juridica;

  return {
    ...dadosInputs,
    profissaoId: !profissaoId ? null : parseInt(profissaoId, 10),
    dataNascimento: !dataNascimentoFormatada ? null : dataNascimentoFormatada,
    cargoRepresentante: !cargoRepresentante ? null : cargoRepresentante,
    escolaridadeId: !escolaridadeId ? null : parseInt(escolaridadeId, 10),
    instituicaoId: !instituicaoId ? null : parseInt(instituicaoId, 10),
    areaAtuacaoId: !areaAtuacaoId ? null : parseInt(areaAtuacaoId, 10),
    sexoId: !sexoId ? null : parseInt(sexoId, 10),
    tipoPessoa: tipoPessoaFormatada,
    cpf: !cpf ? null : parseInt(removeTodasMascaras(cpf), 10),
    telefone: telefone ? parseInt(removeEspacos(removeTodasMascaras(telefone)), 10) : null,
    cep: !cep ? null : parseInt(removeTodasMascaras(cep), 10),
    enderecoPf: {
      ...enderecoPf,
      cep: !enderecoPf?.cep ? null : parseInt(removeTodasMascaras(enderecoPf?.cep), 10),
    },
    enderecoPj: {
      ...enderecoPj,
      cep: !enderecoPj?.cep ? null : parseInt(removeTodasMascaras(enderecoPj?.cep), 10),
    },
    inscricaoEstadual: !cnpj ? null : parseInt(removeTodasMascaras(inscricaoEstadual), 10),
    inscricaoMunicipal: !cnpj ? null : parseInt(removeTodasMascaras(inscricaoMunicipal), 10),
    cnpj: !cnpj ? null : parseInt(removeTodasMascaras(cnpj), 10),
  };
};

export const formatterDadosCadastraisBackToFront = (dadosApi = []) => {
  const pessoaFisica = dadosApi?.[0];
  const pessoaJuridica = dadosApi?.[1];
  const tipoPessoa = pessoaJuridica ? ENUM_TIPO_PESSOA.juridica : ENUM_TIPO_PESSOA.fisica;
  const enderecoPf = pessoaFisica?.endereco?.cep ? pessoaFisica?.endereco : pessoaJuridica?.endereco;
  const enderecoPj = pessoaJuridica?.endereco;

  return {
    id: pessoaFisica?.id,
    idPessoaJuridica: pessoaJuridica?.id,
    sexo: pessoaFisica?.sexo?.descricao,
    sexoId: pessoaFisica?.sexo?.id,
    escolaridade: pessoaFisica?.escolaridade?.descricao,
    escolaridadeId: pessoaFisica?.escolaridade?.id,
    profissao: pessoaFisica?.profissao?.descricao,
    profissaoId: pessoaFisica?.profissao?.id,
    tipoPessoa: tipoPessoa.descricao,
    nome: pessoaFisica?.nome,
    nomeSocial: pessoaFisica?.nomeSocial,
    cpf: cpfMaskView(pessoaFisica?.cpf),
    dataNascimento: convertDatePtBr(pessoaFisica?.dataNascimento),
    email: pessoaFisica?.email,
    telefone: telefoneMask(pessoaFisica?.telefone),
    cargoRepresentante: pessoaJuridica?.cargoRepresentante,
    razaoSocial: pessoaJuridica?.razaoSocial,
    cnpj: cnpjMaskView(pessoaJuridica?.cnpj),
    inscricaoEstadual: pessoaJuridica?.inscricaoEstadual,
    inscricaoMunicipal: pessoaJuridica?.inscricaoMunicipal,
    instituicao: pessoaJuridica?.instituicao?.nomeInstituicao,
    instituicaoId: pessoaJuridica?.instituicao?.id,
    areaAtuacao: pessoaJuridica?.areaAtuacao?.atuacao,
    areaAtuacaoId: pessoaJuridica?.areaAtuacao?.id,
    enderecoPf: { ...enderecoPf, cep: cepMaskView(enderecoPf?.cep) },
    enderecoPj: { ...enderecoPj, cep: cepMaskView(enderecoPj?.cep) },
  };
};

export const formatterDadosCadastraisPessoaJuridicaBackToFront = (dadosApi = {}) => {
  let tipoPessoa = ENUM_TIPO_PESSOA.juridica;

  return {
    idPessoaJuridica: dadosApi?.id,
    tipoPessoa: tipoPessoa.descricao,
    cargoRepresentante: dadosApi?.cargoRepresentante,
    razaoSocial: dadosApi?.razaoSocial,
    cnpj: cnpjMaskView(dadosApi?.cnpj),
    inscricaoEstadual: dadosApi?.inscricaoEstadual,
    inscricaoMunicipal: dadosApi?.inscricaoMunicipal,
    instituicao: dadosApi?.instituicao?.nomeInstituicao,
    instituicaoId: dadosApi?.instituicao?.id,
    areaAtuacao: dadosApi?.areaAtuacao?.atuacao,
    areaAtuacaoId: dadosApi?.areaAtuacao?.id,
    enderecoPj: { ...dadosApi?.endereco, cep: cepMaskView(dadosApi?.endereco?.cep) },
  };
};
export const formatterDadosCadastraisPessoaFisicaBackToFront = (dadosApi = {}) => {
  let tipoPessoa = ENUM_TIPO_PESSOA.fisica;

  return {
    id: dadosApi?.id,
    sexo: dadosApi?.sexo?.descricao,
    sexoId: dadosApi?.sexo?.id,
    escolaridade: dadosApi?.escolaridade?.descricao,
    escolaridadeId: dadosApi?.escolaridade?.id,
    profissao: dadosApi?.profissao?.descricao,
    profissaoId: dadosApi?.profissao?.id,
    tipoPessoa: tipoPessoa.descricao,
    nome: dadosApi?.nome,
    nomeSocial: dadosApi?.nomeSocial,
    cpf: cpfMaskView(dadosApi?.cpf),
    dataNascimento: convertDatePtBr(dadosApi?.dataNascimento),
    email: dadosApi?.email,
    telefone: telefoneMask(dadosApi?.telefone),
    enderecoPf: { ...dadosApi?.endereco, cep: cepMaskView(dadosApi?.endereco?.cep) },
  };
};

export const formatarDadosCadastraisFisicaFrontToBack = dados => {
  dados = removerMascaraInputs(dados);

  return {
    nome: dados.nome,
    nomeSocial: dados.nomeSocial,
    cpf: dados.cpf,
    dataNascimento: dados.dataNascimento,
    profissaoId: dados.profissaoId,
    sexoId: dados.sexoId,
    escolaridadeId: dados.escolaridadeId,
    email: dados.email,
    telefone: dados.telefone,
    tipoPessoaId: dados.tipoPessoa.id,
    endereco: {
      cep: dados?.enderecoPf?.cep ?? dados?.enderecoPj?.cep,
      logradouro: dados?.enderecoPf?.logradouro ?? dados?.enderecoPj?.logradouro,
      numero: dados?.enderecoPf?.numero ?? dados?.enderecoPj?.numero,
      bairro: dados?.enderecoPf?.bairro ?? dados?.enderecoPj?.bairro,
      complemento: dados?.enderecoPf?.complemento ?? dados?.enderecoPj?.complemento,
      cidade: dados?.enderecoPf?.cidade ?? dados?.enderecoPj?.cidade,
      estado: dados?.enderecoPf?.estado ?? dados?.enderecoPj?.estado,
      pais: dados?.enderecoPf?.pais ?? dados?.enderecoPj?.pais,
      id: dados?.enderecoPf?.id ?? 0,
    },
    id: dados?.id || 0,
  };
};

export const formatarDadosCadastraisJuridicaFrontToBack = dados => {
  dados = removerMascaraInputs(dados);

  return {
    cnpj: dados.cnpj,
    inscricaoEstadual: dados.inscricaoEstadual,
    inscricaoMunicipal: dados.inscricaoMunicipal,
    tipoPessoaId: dados.tipoPessoa.id,
    razaoSocial: dados.razaoSocial,
    instituicaoId: dados.instituicaoId,
    areaAtuacaoId: dados.areaAtuacaoId,
    cargoRepresentante: dados.cargoRepresentante,
    endereco: {
      cep: dados?.enderecoPj?.cep,
      logradouro: dados?.enderecoPj?.logradouro,
      numero: dados?.enderecoPj?.numero,
      bairro: dados?.enderecoPj?.bairro,
      complemento: dados?.enderecoPj?.complemento,
      cidade: dados?.enderecoPj?.cidade,
      estado: dados?.enderecoPj?.estado,
      pais: dados?.enderecoPj?.pais,
      id: dados?.enderecoPj?.id ?? 0,
    },
    id: dados?.idPessoaJuridica || 0,
  };
};

export const formatterDadosCadastraisBackToFrontRequerimento = (pessoaFisica, pessoaJuridica, inputDados, user) => {
  const tipoPessoaDescricao =
    user?.document_type === 'CNPJ' ? ENUM_TIPO_PESSOA.juridica.descricao : ENUM_TIPO_PESSOA.fisica.descricao;
  return {
    tipoPessoa: tipoPessoaDescricao,
    // PESSOA FISICA
    nome: pessoaFisica?.nome || inputDados?.nome,
    nomeSocial: pessoaFisica?.nomeSocial || inputDados?.nomeSocial,
    cpf: pessoaFisica?.cpf ? cpfMaskView(pessoaFisica?.cpf) : cpfMaskView(inputDados?.cpf),
    dataNascimento: convertDatePtBr(pessoaFisica?.dataNascimento) || convertDatePtBr(inputDados?.dataNascimento),
    sexoId: pessoaFisica?.sexoId || inputDados?.sexoId,
    email: pessoaFisica?.email || inputDados?.email,
    telefone: telefoneMask(pessoaFisica?.telefone) || telefoneMask(inputDados?.telefone),
    escolaridadeId: pessoaFisica?.escolaridadeId || inputDados?.escolaridadeId,
    profissaoId: pessoaFisica?.profissaoId || inputDados?.profissaoId,

    // PESSOA JURIDICA
    cargoRepresentante: pessoaJuridica?.cargoRepresentante || inputDados?.cargoRepresentante,
    razaoSocial: pessoaJuridica?.razaoSocial || inputDados?.razaoSocial,
    cnpj: pessoaJuridica?.cnpj ? cnpjMaskView(pessoaJuridica?.cnpj) : cnpjMaskView(inputDados?.cnpj),
    inscricaoEstadual: pessoaJuridica?.inscricaoEstadual || inputDados?.inscricaoEstadual,
    inscricaoMunicipal: pessoaJuridica?.inscricaoMunicipal || inputDados?.inscricaoMunicipal,
    instituicaoId: pessoaJuridica?.instituicaoId || inputDados?.instituicaoId,
    areaAtuacaoId: pessoaJuridica?.areaAtuacaoId || inputDados?.areaAtuacaoId,
  };
};

export const formatterDadosCadastraisCadastro = (user, dadosCadastrais) => {
  const tipoPessoa =
    user?.document_type === 'CNPJ' ? ENUM_TIPO_PESSOA.juridica.descricao : ENUM_TIPO_PESSOA.fisica.descricao;

  //Caso seja pessoa jurídica e a pessoa física já tiver cadastro pega os dados da pessoa física cadastrada
  const pessoaFisica =
    tipoPessoa === ENUM_TIPO_PESSOA.juridica.descricao && dadosCadastrais?.[0]?.tipoPessoaId === TIPO_DOCUMENTO.CPF
      ? formatterDadosCadastraisPessoaFisicaBackToFront(dadosCadastrais[0])
      : {
          tipoPessoa: tipoPessoa,
          nome:
            tipoPessoa === ENUM_TIPO_PESSOA.juridica.descricao
              ? primeiraLetraPalavraUpperCase(user?.name_representative)
              : primeiraLetraPalavraUpperCase(user?.name_represented),
          nomeSocial: null,
          cpf:
            tipoPessoa === ENUM_TIPO_PESSOA.juridica.descricao
              ? cpfMaskView(user?.cpf_cnpj_representative)
              : cpfMaskView(user?.cpf_cnpj),
          dataNascimento: null,
          sexoId: '',
          email: user?.email || null,
          telefone: null,
          escolaridadeId: '',
          profissaoId: '',
          enderecoPf: {
            pais: null,
            cep: null,
            logradouro: null,
            complemento: null,
            numero: null,
            bairro: null,
            cidade: null,
            estado: null,
          },
        };

  //Caso seja pessoa jurídica e a pessoa jurídica já tiver cadastrada pega os dados da pessoa jurídica cadastrada
  const pessoaJuridica =
    tipoPessoa === ENUM_TIPO_PESSOA.juridica.descricao && dadosCadastrais?.[0]?.tipoPessoaId === TIPO_DOCUMENTO.CNPJ
      ? formatterDadosCadastraisPessoaJuridicaBackToFront(dadosCadastrais[0])
      : {
          tipoPessoa: tipoPessoa,
          cargoRepresentante: null,
          razaoSocial: user?.name_represented,
          cnpj: cnpjMaskView(user?.cpf_cnpj),
          inscricaoEstadual: null,
          inscricaoMunicipal: null,
          instituicaoId: '',
          areaAtuacaoId: '',
          enderecoPj: {
            pais: null,
            cep: null,
            logradouro: null,
            complemento: null,
            numero: null,
            bairro: null,
            cidade: null,
            estado: null,
          },
        };

  let pessoaFormatada = { ...pessoaFisica };

  if (tipoPessoa === ENUM_TIPO_PESSOA.juridica.descricao) pessoaFormatada = { ...pessoaFormatada, ...pessoaJuridica };

  return pessoaFormatada;
};
